import { createFileRoute, redirect } from "@tanstack/react-router";

// Redirects rather than 404s: the old address is in the index and in links already sent.
export const Route = createFileRoute("/v2/features")({
  beforeLoad: () => {
    throw redirect({ to: "/v2/operating-system", replace: true });
  },
});
